import React, { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import "../styles/ChapterLectures.css";
import mlogo from "../assets/ntmlogo.jpg"; // ✅ Import logo

const ChapterLectures = () => {
  const { subject, chapterIndex } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [navigate]);

  const chapterLectures = {
    Science: {
      0:[
  {
    "name": "Introduction Videos",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17127637923662649384/17127637923662649384_649384.m3u8"
  },
        {
          name: "Basics Of Chemistry",
          youtubeUrl: "https://www.youtube.com/watch?v=NUF159lXOBw"
        },
  {
    "name": "Basics of physics Class 10th",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/1712667138565534134/1712667138565534134_534134.m3u8"
  },
  {
    "name": "Basics of Biology",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17127537215601649384/17127537215601649384_649384.m3u8"
  },
  {
    "name": "Chemical reactions and equations Lecture - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17131970117723649384/17131970117723649384_649384.m3u8"
  },
  {
    "name": "Chemical Reactions and Equations Lec-2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17133600563599649384/17133600563599649384_649384.m3u8"
  },
  {
    "name": "Chemical Reactions and Equations Lec - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17134452954759649384/17134452954759649384_649384.m3u8"
  },
  {
    "name": "ACP solve + Lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17138010498958649384/17138010498958649384_649384.m3u8"
  },
  {
    "name": "Chemical reactions and equations L5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17138774499408649384/17138774499408649384_649384.m3u8"
  },
  {
    "name": "Chemical reactions and equations L6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17139644014533649384/17139644014533649384_649384.m3u8"
  },
  {
    "name": "Chemical reactions and equations L7",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17140502365511649384/17140502365511649384_649384.m3u8"
  },
  {
    "name": "ACP solve + complete Reaction revision",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17143961581787649384/17143961581787649384_649384.m3u8"
  },
  {
    "name": "Life Processes Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17144825599737649384/17144825599737649384_649384.m3u8"
  },
  {
    "name": "Life process LEC -2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17145694219206649384/17145694219206649384_649384.m3u8"
  },
  {
    "name": "Life process LEC -3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17146550858275649384/17146550858275649384_649384.m3u8"
  },
  {
    "name": "Doubt Sessions + Lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17150105266682649384/17150105266682649384_649384.m3u8"
  },
  {
    "name": "Life Processes lecture 6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17151735781192649384/17151735781192649384_649384.m3u8"
  },
  {
    "name": "Life Processes lecture 7",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17152599573616649384/17152599573616649384_649384.m3u8"
  },
  {
    "name": "Complete NCERT Activity ( Life Processes)",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17156925525362649384/17156925525362649384_649384.m3u8"
  },
  {
    "name": "Light Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17157794545257649384/17157794545257649384_649384.m3u8"
  },
  {
    "name": "Science doubt class (Extra class )",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17161235046344649384/17161235046344649384_649384.m3u8"
  },
  {
    "name": "Light Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17162191913272649384/17162191913272649384_649384.m3u8"
  },
  {
    "name": "Light lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17162977591186649384/17162977591186649384_649384.m3u8"
  },
  {
    "name": "Light lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17163837245952649384/17163837245952649384_649384.m3u8"
  },
  {
    "name": "Light Lec-5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17164706945137649384/17164706945137649384_649384.m3u8"
  },
  {
    "name": "ACP Solve +Light Lec-6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17168252698711649384/17168252698711649384_649384.m3u8"
  },
  {
    "name": "Light Lecture 7",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17169021711956649384/17169021711956649384_649384.m3u8"
  },
  {
    "name": "Acid , Base and Salts lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17178522829284649384/17178522829284649384_649384.m3u8"
  },
  {
    "name": "Acid , Base and Salts lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17179391311935649384/17179391311935649384_649384.m3u8"
  },
  {
    "name": "Acid , Base and Salts lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17180249667889649384/17180249667889649384_649384.m3u8"
  },
  {
    "name": "Acid , Base and Salts lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17181114422642649384/17181114422642649384_649384.m3u8"
  },
  {
    "name": "Acid , Base and Salts lecture 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17181979211747649384/17181979211747649384_649384.m3u8"
  },
  {
    "name": "Acid, Base and Salts Lecture 6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17182839586994649384/17182839586994649384_649384.m3u8"
  },
  {
    "name": "Doubt solving class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17186403267539649384/17186403267539649384_649384.m3u8"
  },
  {
    "name": "Human eye Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17187167781412649384/17187167781412649384_649384.m3u8"
  },
  {
    "name": "Human eye lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17188028707546649384/17188028707546649384_649384.m3u8"
  },
  {
    "name": "Human Eye|Lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17188895186220649384/17188895186220649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17200122798421649384/17200122798421649384_649384.m3u8"
  },
  {
    "name": "Human Eye|Lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17200976893750649384/17200976893750649384_649384.m3u8"
  },
  {
    "name": "Control and coordination lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17201849262443649384/17201849262443649384_649384.m3u8"
  },
  {
    "name": "L2 - Control and coordination",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17204531151224649384/17204531151224649384_649384.m3u8"
  },
  {
    "name": "L3- Control and coordination",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17205310642213649384/17205310642213649384_649384.m3u8"
  },
  {
    "name": "L4 - control and coordination",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17206170098769649384/17206170098769649384_649384.m3u8"
  },
  {
    "name": "Control and coordination L5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17207044432043649384/17207044432043649384_649384.m3u8"
  },
  {
    "name": "Control and coordination NCERT Activity",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17210484872245649384/17210484872245649384_649384.m3u8"
  },
  {
    "name": "Electricity lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17211352602062649384/17211352602062649384_649384.m3u8"
  },
  {
    "name": "Electricity lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17212216083244649384/17212216083244649384_649384.m3u8"
  },
  {
    "name": "Electricity Lec-3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17213086397666649384/17213086397666649384_649384.m3u8"
  },
  {
    "name": "Electricity Lecture 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17217404976141649384/17217404976141649384_649384.m3u8"
  },
  {
    "name": "Electricity Lecture 6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17218269228750649384/17218269228750649384_649384.m3u8"
  },
  {
    "name": "Electricity question practice ( NCERT +PYQ)",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17219124552590649384/17219124552590649384_649384.m3u8"
  },
  {
    "name": "Doubt solving class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17222678298178649384/17222678298178649384_649384.m3u8"
  },
  {
    "name": "Metals and Non Metals-1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17224301148373649384/17224301148373649384_649384.m3u8"
  },
  {
    "name": "Metals and Non Metals-2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17225181899237649384/17225181899237649384_649384.m3u8"
  },
  {
    "name": "Metals and Non Metals - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17226040918045649384/17226040918045649384_649384.m3u8"
  },
  {
    "name": "Metals and Non metals-4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17228627007280649384/17228627007280649384_649384.m3u8"
  },
  {
    "name": "Late night talk with Prashant Sir",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17231392922958649384/17231392922958649384_649384.m3u8"
  },
  {
    "name": "Metals and Non Metals-5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17234776689711649384/17234776689711649384_649384.m3u8"
  },
  {
    "name": "Metals and Non Metals-6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17235542773827649384/17235542773827649384_649384.m3u8"
  },
  {
    "name": "Metals and Non Metals-7",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17236415539041649384/17236415539041649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17237266268094649384/17237266268094649384_649384.m3u8"
  },
  {
    "name": "How do Organisms Reproduce -1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17241603136531649384/17241603136531649384_649384.m3u8"
  },
  {
    "name": "How do Organisms Reproduce-2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17242455128205649384/17242455128205649384_649384.m3u8"
  },
  {
    "name": "How do organisms Reproduce-3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17243328766892649384/17243328766892649384_649384.m3u8"
  },
  {
    "name": "How do organism Reproduce -4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17248508008072649384/17248508008072649384_649384.m3u8"
  },
  {
    "name": "Late night talk with Prashant Sir",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17248664426002649384/17248664426002649384_649384.m3u8"
  },
  {
    "name": "How do organism Reproduce -5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17249464951828649384/17249464951828649384_649384.m3u8"
  },
  {
    "name": "How Do Organisms Reproduce - 6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17251967381268649384/17251967381268649384_649384.m3u8"
  },
  {
    "name": "How do organisms Reproduce-7",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17252909095353649384/17252909095353649384_649384.m3u8"
  },
  {
    "name": "Magnetic effects of current -1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17253698807925649384/17253698807925649384_649384.m3u8"
  },
  {
    "name": "Magnetic effects of current -2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17254553128450649384/17254553128450649384_649384.m3u8"
  },
  {
    "name": "Magnetic effect of current-3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17258968201772649384/17258968201772649384_649384.m3u8"
  },
  {
    "name": "Magnetic effect of current-4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17259738208696649384/17259738208696649384_649384.m3u8"
  },
  {
    "name": "NCERT Magnetic effects of current",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17260593215441649384/17260593215441649384_649384.m3u8"
  },
  {
    "name": "Doubt class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17265010976091649384/17265010976091649384_649384.m3u8"
  },
  {
    "name": "Electricity Revision",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17267580928151649384/17267580928151649384_649384.m3u8"
  },
  {
    "name": "Carbon and its compounds lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17271073583747649384/17271073583747649384_649384.m3u8"
  },
  {
    "name": "Carbon and its compounds lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17271832944057649384/17271832944057649384_649384.m3u8"
  },
  {
    "name": "Carbon and its compounds lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172727142951271815381/172727142951271815381_1815381.m3u8"
  },
  {
    "name": "Carbon and its compounds L5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172778815681591815381/172778815681591815381_1815381.m3u8"
  },
  {
    "name": "Carbon and its compounds L6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172787465637211815381/172787465637211815381_1815381.m3u8"
  },
  {
    "name": "Carbon and its compound 7",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172831638273281815381/172831638273281815381_1815381.m3u8"
  },
  {
    "name": "Carbon and its compound 8",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172839396627861815381/172839396627861815381_1815381.m3u8"
  },
  {
    "name": "Carbon and its compound 9",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172848000547861815381/172848000547861815381_1815381.m3u8"
  },
  {
    "name": "Carbon and its compound 10",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172856740057771815381/172856740057771815381_1815381.m3u8"
  },
  {
    "name": "Doubt class + Revision",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172882423816101815381/172882423816101815381_1815381.m3u8"
  },
  {
    "name": "Our Environment Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172899870876231815381/172899870876231815381_1815381.m3u8"
  },
  {
    "name": "Our Environment Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172908500992531815381/172908500992531815381_1815381.m3u8"
  },
  {
    "name": "Heredity and Evolution Lecture No 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/173013084075151815381/173013084075151815381_1815381.m3u8"
  },
  {
    "name": "Heredity and Evolution Lecture No 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/173021778223461815381/173021778223461815381_1815381.m3u8"
  },
  {
    "name": "Heredity and Evolution Lecture No 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/173029357025641815381/173029357025641815381_1815381.m3u8"
  },
  {
    "name": "Complete Evolution",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/173073473665341815381/173073473665341815381_1815381.m3u8"
  },
  {
    "name": "Heredity and Evolution - 4 Final Lecture",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/173081238721711815381/173081238721711815381_1815381.m3u8"
  }
],
      1:
[
  { name: "ACP 1 - Chemical Reactions and Equations", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/627703850713643300.pdf" },
  { name: "ACP 1 Solution - Chemical Reactions and Equations", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/121996321776111420.pdf" },
  { name: "ACP 2 - Life Processes", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/740664551266240800.pdf" },
  { name: "ACP 2 Solution - Life Process", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/524575831186621500.pdf" },
  { name: "ACP - Light", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/232074727049818340.pdf" },
  { name: "ACP - Light with solution", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/389341656744918340.pdf" },
  { name: "ACP Acid Base and Salts", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/894673857366001400.pdf" },
  { name: "ACP(Solution )Acid Base and Salts", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/389769000396221950.pdf" },
  { name: "ACP with solution Human Eye and colourful World", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/798655470174374100.pdf" },
  { name: "ACP - control and Coordination", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540/course_pdf/4735626396496101873537600.pdf" },
  { name: "ACP Electricity with solution", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/840614258114554600.pdf" },
  { name: "ACP -Metals and non Metals", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/195700803349298180.pdf" },
  { name: "ACP - Magnetic effect of Electric current (", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/354814027979072400.pdf" },
  { name: "ACP Carbon and its Compounds", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/74904985792522720.pdf" },
  { name: "ACP -How do organisms Reproduce", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/396268201901569340.pdf" },
  { name: "ACP - Magnetic effect of Electric current with Solutions", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/96570067748585100.pdf" },
  { name: "ACP - Heredity and Evolution", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/119219569837899120.pdf" },
  { name: "Electricity Revision", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/418305685856962400.pdf" },
  { name: "Chemical reactions and equations L4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/721691565994801200.pdf" },
  { name: "Acid Base and Salts LEC 5 part 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/832018672838415200.pdf" },
  { name: "Acid Base and Salts LEC 6", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/649452294346953000.pdf" },
  { name: "Metals and Non Metals -2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252707945_664262731300406400_video_VOD.pdf" },
  { name: "ACP_Control_and_Coordination_with_Solutions_Prashant_Kirad_", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252706765_382662906773507600_video_VOD.pdf" },
  { name: "ACP with Solutions - Life Processes (Prashant Kirad)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252705637_642549950228036400_video_VOD.pdf" },
  { name: "ACP - Light ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252704683_80966424501208430_video_VOD.pdf" },
  { name: "ACP - Life Processes (Prashant Kirad)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252703950_212715778502995700_video_VOD.pdf" },
  { name: "ACP - Chemical Reactions and Equations ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252619166_169804497895668400_video_VOD.pdf" },
  { name: "L7 Acid Bases and Salts ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252607095_301934934711293760_video_VOD.pdf" },
  { name: "L8 LIFE PROCESSES ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252604786_212758018227930900_video_VOD.pdf" },
  { name: "L8 Chemical Reaction & Equation ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252631233_220488936354604670_video_VOD.pdf" },
  { name: "L3-Chemical Reaction & Equation ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252637060_221444606590336830_video_VOD.pdf" },
  { name: "L4 Chemical Reaction & Equation (Prashant Kirad)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252625675_177457628586182980_video_VOD.pdf" },
  { name: "L5 Chemical Reaction & Equation ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252616927_709438704998743800_video_VOD.pdf" },
  { name: "L6 Chemical Reactions & Equations (Prashant Kirad)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252600317_621964079486516600_video_VOD.pdf" },
  { name: "L7 Chemical Reaction & Equation (Prashant Kirad)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252658726_736623133062998000_video_VOD.pdf" },
  { name: "L1 LIFE PROCESSES ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252642016_664528052381242200_video_VOD.pdf" },
  { name: "L2 LIFE PROCESSES ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252651913_831576166238611800_video_VOD.pdf" },
  { name: "L3 LIFE PROCESSES ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252620651_815355075233290900_video_VOD.pdf" },
  { name: "L4 LIFE PROCESSES ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252611752_784478640469127700_video_VOD.pdf" },
  { name: "L5 LIFE PROCESSES ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252602780_878458180863282300_video_VOD.pdf" },
  { name: "L7 LIFE PROCESSES ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252608782_106755616566175250_video_VOD.pdf" },
  { name: "Life Processes NCERT Hack (Prashant Kirad)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252661773_784133066892904000_video_VOD.pdf" },
  { name: "L1 Light ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252644639_690588961256471800_video_VOD.pdf" },
  { name: "L2 Light (Prashant Kirad)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252653800_261486046262578600_video_VOD.pdf" },
  { name: "L3 Light (Prashant Kirad)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252614382_391550006214355400_video_VOD.pdf" },
  { name: "L5 Light (Prashant Kirad)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252683437_38831096158831490_video_VOD.pdf" },
  { name: "L1 Acid Bases and Salts ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252663438_558890880090239800_video_VOD.pdf" },
  { name: "L2 Acids Bases and Salts (Prashant Kirad)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252634007_297653176661435650_video_VOD.pdf" },
  { name: "L4 acid base", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252615769_311074115721266900_video_VOD.pdf" },
  { name: "L6 Acid Bases and Salts ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252657003_809041317237547900_video_VOD.pdf" },
  { name: "L1 Human Eye & Colorful World ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252641380_784044268356474400_video_VOD.pdf" },
  { name: "L2 Human Eye & Colorful World ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252650403_223505737374542000_video_VOD.pdf" },
  { name: "L3 Human Eye & Colorful World ( Prashant Kirad )-merged (1)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252639851_402923310249220700_video_VOD.pdf" },
  { name: "l4 human eye", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252680131_615866226244836600_video_VOD.pdf" },
  { name: "L 1 Control and Coordination", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252666139_688119489911571600_video_VOD.pdf" },
  { name: "L2 control and coordination", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252646287_224477749891292220_video_VOD.pdf" },
  { name: "L3 control and Coordination", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252639565_220403587635999700_video_VOD.pdf" },
  { name: "L4 Control and Coordination ( Prashant Kirad )pdf", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252628140_766658139134024200_video_VOD.pdf" },
  { name: "L5 Control and Coordination ( Prashant Kirad )", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252654531_46674156616306936_video_VOD.pdf" },
  { name: "L1 electricity", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252669457_501604717384850240_video_VOD.pdf" },
  { name: "L2 Electricity", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252648619_415560495554958660_video_VOD.pdf" },
  { name: "L3 electricity", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252622472_163624295708011680_video_VOD.pdf" },
  { name: "L4+5 Electricity", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252681903_591917890116746000_video_VOD.pdf" },
  { name: "L 6 Electricity", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252593493_603710564894404500_video_VOD.pdf" },
  { name: "Metals and Non Metals L-1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252596303_157692905224969280_video_VOD.pdf" },
  { name: "Metals and Non Metals L-2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252598567_872978728672547700_video_VOD.pdf" },
  { name: "Metals and Non Metals L-3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252573017_878137615101965800_video_VOD.pdf" },
  { name: "Metals and Non Metals L-4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252575541_589455303556979800_video_VOD.pdf" },
  { name: "Metals and Non Metals L-5", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252578811_73459298851748980_video_VOD.pdf" },
  { name: "Metals and Non Metals L-6", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252580642_10717322788331928_video_VOD.pdf" },
  { name: "Metals and Non Metals L-7", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252698370_482172248960577500_video_VOD.pdf" },
  { name: "How do organism Reproduce 1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252700113_58913882214523300_video_VOD.pdf" },
  { name: "How do organism Reproduce 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/163571743513468450.pdf" },
  { name: "How do organism Reproduce 3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252671429_894611302689737000_video_VOD.pdf" },
  { name: "How do organism Reproduce 4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252673211_678881874670041100_video_VOD.pdf" },
  { name: "How do organism Reproduce 5", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/417539397175191500.pdf" },
  { name: "How do organism Reproduce 6", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252678418_550355833488188000_video_VOD.pdf" },
  { name: "How do organism Reproduce 7", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252610216_120061942487067170_video_VOD.pdf" },
  { name: "Magnetic effect of electric current 1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252585780_357678148798885700_video_VOD.pdf" },
  { name: "Magnetic effect of electric current 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252588201_38269752987918730_video_VOD.pdf" },
  { name: "Magnetic effect of electric current 3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252591372_841333383347678700_video_VOD.pdf" },
  { name: "Magnetic effect of electric current 4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252696582_644820107847809200_video_VOD.pdf" },
  { name: "Electricity revision", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252709764_627568715435183500_video_VOD.pdf" },
  { name: "Carbon and its compound 1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252685697_533737085417561860_video_VOD.pdf" },
  { name: "Carbon and its compound 2+3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252687325_43371594927063380_video_VOD.pdf" },
  { name: "Carbon and its compound 4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252689255_597026166553608700_video_VOD.pdf" },
  { name: "Carbon and its compound 5", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252690720_733627130019311400_video_VOD.pdf" },
  { name: "Carbon and its compound 6", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252691647_483083646780773440_video_VOD.pdf" },
  { name: "Carbon and its compound 7", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252693514_525121786511356540_video_VOD.pdf" },
  { name: "Carbon and its compound 8", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252694793_134946680674872030_video_VOD.pdf" },
  { name: "Carbon and its compound 9", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/521718559546962000.pdf" },
  { name: "Carbon and its compound 10", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252583377_551497529677770300_video_VOD.pdf" },
  { name: "Our enviroment 1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sunnynotews/1729252569073_892755359333031000_video_VOD.pdf" },
  { name: "Our enviroment 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/410580474575175500.pdf" },
  { name: "Metals and non metals NCERT Hack (Prashant Kirad)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/730240964917763500.pdf" },
  { name: "Heredity and evolution - 1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/653319795603380900.pdf" },
  { name: "Heredity and evolution - 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/194568334907540960.pdf" },
  { name: "Heredity and evolution - 3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/831611041378410800.pdf" },
  { name: "Complete Evolution", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/700345615706836100.pdf" },
  { name: "Heredity and Evolution ~ Final", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/157947410513934000.pdf" }
],
    },
    Maths: {
      0:[
  {
    "name": "Real Numbers | Lecture 1",
    youtubeUrl: "https://www.youtube.com/watch?v=6yYg64NzEK4"
  },
  {
    "name": "Real Numbers | Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17127637923662649384/17127637923662649384_649384.m3u8"
  },
  {
    "name": "Real Numbers | Lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17129371342512649384/17129371342512649384_649384.m3u8"
  },
  {
    "name": "DPP Solving and Doubt Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17132822008732649384/17132822008732649384_649384.m3u8"
  },
  {
    "name": "Polynomials | Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17133693708701649384/17133693708701649384_649384.m3u8"
  },
  {
    "name": "Polynomials | Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17134551697755649384/17134551697755649384_649384.m3u8"
  },
  {
    "name": "Polynomials | Lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17135415282903649384/17135415282903649384_649384.m3u8"
  },
  {
    "name": "Polynomials | Lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17138871113253649384/17138871113253649384_649384.m3u8"
  },
  {
    "name": "DPP Solving cum Doubt Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17139725638892649384/17139725638892649384_649384.m3u8"
  },
  {
    "name": "Pair Of Linear Eq in 2 Variables | Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17140595503381649384/17140595503381649384_649384.m3u8"
  },
  {
    "name": "Pair Of Linear Eq in 2 Variables | Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17141460536824649384/17141460536824649384_649384.m3u8"
  },
  {
    "name": "Pair Of Linear Eq in 2 Variables | Lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17144928065342649384/17144928065342649384_649384.m3u8"
  },
  {
    "name": "Pair Of Linear Eq in 2 Variables | Lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17145783022534649384/17145783022534649384_649384.m3u8"
  },
  {
    "name": "Pair Of Linear Eq in 2 Variables | Lecture 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17146657352563649384/17146657352563649384_649384.m3u8"
  },
  {
    "name": "DPP Solving cum Doubt Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17147519235900649384/17147519235900649384_649384.m3u8"
  },
  {
    "name": "Quadratic Equations | Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17150966356342649384/17150966356342649384_649384.m3u8"
  },
  {
    "name": "Quadratic Equations | Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17151832999338649384/17151832999338649384_649384.m3u8"
  },
  {
    "name": "Quadratic Equations | Lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17152700065912649384/17152700065912649384_649384.m3u8"
  },
  {
    "name": "DPP Solving cum Doubt Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17153550861285649384/17153550861285649384_649384.m3u8"
  },
  {
    "name": "Quadratic Equations | Lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17157012188479649384/17157012188479649384_649384.m3u8"
  },
  {
    "name": "Quadratic Equations | Lecture 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17157871003077649384/17157871003077649384_649384.m3u8"
  },
  {
    "name": "Quadratic Equation Lec-6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17159600766765649384/17159600766765649384_649384.m3u8"
  },
  {
    "name": "Doubt Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17163052395820649384/17163052395820649384_649384.m3u8"
  },
  {
    "name": "Triangles | Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17163929069468649384/17163929069468649384_649384.m3u8"
  },
  {
    "name": "Triangles | Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17164785434246649384/17164785434246649384_649384.m3u8"
  },
  {
    "name": "Triangles | Lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17165655241554649384/17165655241554649384_649384.m3u8"
  },
  {
    "name": "Triangles | Lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17169117839592649384/17169117839592649384_649384.m3u8"
  },
  {
    "name": "Triangles | Lecture 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17169977277309649384/17169977277309649384_649384.m3u8"
  },
  {
    "name": "Triangles | Lecture 6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17170838739405649384/17170838739405649384_649384.m3u8"
  },
  {
    "name": "Trigonometry | Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17183787982575649384/17183787982575649384_649384.m3u8"
  },
  {
    "name": "Trigonometry | Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17184653924894649384/17184653924894649384_649384.m3u8"
  },
  {
    "name": "Trigonometry | Lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17185521872754649384/17185521872754649384_649384.m3u8"
  },
  {
    "name": "Trigonometry | Lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17187266273378649384/17187266273378649384_649384.m3u8"
  },
  {
    "name": "Trigonometry | Lecture 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17188114594487649384/17188114594487649384_649384.m3u8"
  },
  {
    "name": "Trigonometry | Lecture 6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17188979608589649384/17188979608589649384_649384.m3u8"
  },
  {
    "name": "Trigonometry | Lecture 7",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17189844558492649384/17189844558492649384_649384.m3u8"
  },
  {
    "name": "Recap Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17199337187487649384/17199337187487649384_649384.m3u8"
  },
  {
    "name": "Trigonometry | Lecture 8",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17201072148079649384/17201072148079649384_649384.m3u8"
  },
  {
    "name": "Trigonometry | Lecture 9",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17201945531728649384/17201945531728649384_649384.m3u8"
  },
  {
    "name": "Trigonometry | Lecture 10",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17205408742212649384/17205408742212649384_649384.m3u8"
  },
  {
    "name": "Trigonometry | Lecture 11",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17206261232662649384/17206261232662649384_649384.m3u8"
  },
  {
    "name": "Trigonometry | Lecture 12",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17207123403150649384/17207123403150649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17207985627832649384/17207985627832649384_649384.m3u8"
  },
  {
    "name": "Some Applications of Trigonometry -1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17211459917785649384/17211459917785649384_649384.m3u8"
  },
  {
    "name": "Some Applications of Trigonometry - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17212322626813649384/17212322626813649384_649384.m3u8"
  },
  {
    "name": "Some Applications of Trigonometry - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17213178213821649384/17213178213821649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17214040194493649384/17214040194493649384_649384.m3u8"
  },
  {
    "name": "AP 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17217495494378649384/17217495494378649384_649384.m3u8"
  },
  {
    "name": "AP 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17218362553868649384/17218362553868649384_649384.m3u8"
  },
  {
    "name": "AP 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17219230998502649384/17219230998502649384_649384.m3u8"
  },
  {
    "name": "AP 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17220087841342649384/17220087841342649384_649384.m3u8"
  },
  {
    "name": "AP 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17220948007035649384/17220948007035649384_649384.m3u8"
  },
  {
    "name": "AP-6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17221820786502649384/17221820786502649384_649384.m3u8"
  },
  {
    "name": "Doubt Class + Coordinate Geometry 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17232177413648649384/17232177413648649384_649384.m3u8"
  },
  {
    "name": "Coordinate Geometry | Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17233045919559649384/17233045919559649384_649384.m3u8"
  },
  {
    "name": "Coordinate Geometry | Lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17233925378345649384/17233925378345649384_649384.m3u8"
  },
  {
    "name": "Coordinate Geometry | Lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17235632149748649384/17235632149748649384_649384.m3u8"
  },
  {
    "name": "Coordinate Geometry | Lecture 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17236484366039649384/17236484366039649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17237360518467649384/17237360518467649384_649384.m3u8"
  },
  {
    "name": "DPP 15-18 Discussion",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17238223313872649384/17238223313872649384_649384.m3u8"
  },
  {
    "name": "Half Yearly Revision | Triangles 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17241697415906649384/17241697415906649384_649384.m3u8"
  },
  {
    "name": "Half Yearly Revision | Triangles 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17242547994359649384/17242547994359649384_649384.m3u8"
  },
  {
    "name": "Half Yearly Revision | Triangles 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17244274567171649384/17244274567171649384_649384.m3u8"
  },
  {
    "name": "Half Yearly Revision | Triangles 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17247722436004649384/17247722436004649384_649384.m3u8"
  },
  {
    "name": "Half Yearly Revision | Pair Of Linear Eq 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17248593366655649384/17248593366655649384_649384.m3u8"
  },
  {
    "name": "Half Yearly Revision | Pair Of Linear Eq 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17250319205142649384/17250319205142649384_649384.m3u8"
  },
  {
    "name": "Half Yearly Revision | Pair Of Linear Eq 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17253766884728649384/17253766884728649384_649384.m3u8"
  },
  {
    "name": "Half Yearly Revision | Quadratic Eq 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17254641166348649384/17254641166348649384_649384.m3u8"
  },
  {
    "name": "Half Yearly Revision | Quadratic Eq 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17256365147619649384/17256365147619649384_649384.m3u8"
  },
  {
    "name": "Half Yearly Revision | Real Number Important Questions",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17259823471606649384/17259823471606649384_649384.m3u8"
  },
  {
    "name": "Half Yearly Revision | Polynomials Important Questions",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17260692492874649384/17260692492874649384_649384.m3u8"
  },
  {
    "name": "Circles | Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17265878073193649384/17265878073193649384_649384.m3u8"
  },
  {
    "name": "Circles | Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17266735317556649384/17266735317556649384_649384.m3u8"
  },
  {
    "name": "Circle|Lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17267604948096649384/17267604948096649384_649384.m3u8"
  },
  {
    "name": "Circles | Lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17268452417301649384/17268452417301649384_649384.m3u8"
  },
  {
    "name": "Area Related to Circles | Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172736464482251815381/172736464482251815381_1815381.m3u8"
  },
  {
    "name": "Area Related to Circles | Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172745146062961815381/172745146062961815381_1815381.m3u8"
  },
  {
    "name": "Area Related to Circles | Lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172770146155001815381/172770146155001815381_1815381.m3u8"
  },
  {
    "name": "NCERT and DPPs discussion |Surface Area and Volume | Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172840157790441815381/172840157790441815381_1815381.m3u8"
  },
  {
    "name": "Surface Area and Volume | Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172857459049321815381/172857459049321815381_1815381.m3u8"
  },
  {
    "name": "Surface Area and Volume | Lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172866101963571815381/172866101963571815381_1815381.m3u8"
  },
  {
    "name": "Surface Area and Volume | Lecture 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172900628539191815381/172900628539191815381_1815381.m3u8"
  },
  {
    "name": "Statistics | Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172918054741191815381/172918054741191815381_1815381.m3u8"
  },
  {
    "name": "Statistics | Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172926652637711815381/172926652637711815381_1815381.m3u8"
  },
  {
    "name": "Statistics | Lecture 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172961122145341815381/172961122145341815381_1815381.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172969790150071815381/172969790150071815381_1815381.m3u8"
  },
  {
    "name": "Probability | Lecture 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172978423973451815381/172978423973451815381_1815381.m3u8"
  },
  {
    "name": "Probability | Lecture 2 ~ Official Last Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172987115832861815381/172987115832861815381_1815381.m3u8"
  }
],
      1: [
  { name: "DPP #1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/835153668013576300.pdf" },
  { name: "DPP #2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/381212617807938400.pdf" },
  { name: "DPP #3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/329223029297522940.pdf" },
  { name: "DPP #4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/678852496560783000.pdf" },
  { name: "DPP #5", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/63107337858534300.pdf" },
  { name: "DPP #6", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540/course_pdf/3129400773834954336531200.pdf" },
  { name: "DPP #7", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/238082511822435800.pdf" },
  { name: "DPP #8", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/824854236457198700.pdf" },
  { name: "DPP #9", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/80277616854577550.pdf" },
  { name: "DPP #10", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/703570703178416800.pdf" },
  { name: "DPP #11", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/208624261630370200.pdf" },
  { name: "DPP #12", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/706526584385632800.pdf" },
  { name: "DPP #13", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540/course_pdf/1822529290791847707045100.pdf" },
  { name: "DPP #14", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/884839899057485800.pdf" },
  { name: "DPP #15", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/196696848955207170.pdf" },
  { name: "DPP #16", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/863916778900802400.pdf" },
  { name: "DPP #17", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/416110119302752900.pdf" },
  { name: "DPP #18", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/604166130475383000.pdf" },
  { name: "DPP #19", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/219025147750256450.pdf" },
  { name: "DPP #20", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/475656270734817400.pdf" },
  { name: "DPP #21", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/94091378978015280.pdf" },
  { name: "DPP #22", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/336668950700609150.pdf" },
  { name: "Real numbers Lec -1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540/course_pdf/6230635122537064325240740.pdf" },
  { name: "Real Numbers Lec-2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/135103066473446740.pdf" },
  { name: "Real Numbers Lec-3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540/course_pdf/690919728011606794847700.pdf" },
  { name: "Doubt Class #1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/790234280047601800.pdf" },
  { name: "Polynomials Lec - 1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/290881990736756160.pdf" },
  { name: "Polynomials Lec -2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/731613206030621300.pdf" },
  { name: "Polynomials Lec-3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/78725336893875760.pdf" },
  { name: "Polynomials Lec-4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/597321843357252000.pdf" },
  { name: "Pair of Linear equations L1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/845888074171907600.pdf" },
  { name: "Pair of Linear equations L2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/625760234282012200.pdf" },
  { name: "Pair of Linear equations in 2 Var L3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/544596013533881200.pdf" },
  { name: "Pair of Linear equations Lec-4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/97799956365074940.pdf" },
  { name: "Pair of Linear equations Lec-5", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/486560734477693200.pdf" },
  { name: "Quadratic equation Lec-1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/329011771486915500.pdf" },
  { name: "Quatratic Equation Lec-2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/393977804442221500.pdf" },
  { name: "Quadratic equation Lec-3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/216803358346372640.pdf" },
  { name: "Quadratic Equation Lec-4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/393415283543932540.pdf" },
  { name: "Quadratic Equations LEC -5", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/93583526450562720.pdf" },
  { name: "Quadratic Equation L-6", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/252697913981793630.pdf" },
  { name: "Triangles L1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/623255636232658000.pdf" },
  { name: "Triangles Lec-2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/648705782383389600.pdf" },
  { name: "Triangles Lec-3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/162042040158885250.pdf" },
  { name: "Triangles Lec -4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/568036343387820500.pdf" },
  { name: "Triangles -5", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/798524544013263900.pdf" },
  { name: "Triangles lec-6", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/103096393506383620.pdf" },
  { name: "Trigonometry L1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/4362477226461148.pdf" },
  { name: "Trigonometry L2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540/course_pdf/7271462221742069344368480.pdf" },
  { name: "Trigonometry L3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/861008178055158100.pdf" },
  { name: "Trigonometry L4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/450501175274632300.pdf" },
  { name: "Trigonometry L6", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/175936271789777180.pdf" },
  { name: "Trigonometry L5", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/122926094615589920.pdf" },
  { name: "Trigonometry L7", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540/course_pdf/5586561660855814408264800.pdf" },
  { name: "Trigonometry L8", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/364008081090451800.pdf" },
  { name: "Trigonometry L9", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/819686080059700400.pdf" },
  { name: "Trigonometry L10", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/431750639421205760.pdf" },
  { name: "Trigonometry L11", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/239673018623187400.pdf" },
  { name: "Trigonometry L12", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/975154679924461.pdf" },
  { name: "Some applications of trigno 1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/512926501736074900.pdf" },
  { name: "Some applications of trigno 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/611427423414864100.pdf" },
  { name: "Some applications of trigno 3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/873331498872368500.pdf" },
  { name: "AP Lecture 1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/691255944417134200.pdf" },
  { name: "AP Lecture 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/521867257207995500.pdf" },
  { name: "AP lecture 3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/762607086944557300.pdf" },
  { name: "AP lecture 4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/583316739505975900.pdf" },
  { name: "AP lecture 5", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/807796521436509400.pdf" },
  { name: "AP lecture 6", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/787441533413798800.pdf" },
  { name: "Coordinate Geometry -1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/224169593634472930.pdf" },
  { name: "Coordinate Geometry -2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/369471802807785860.pdf" },
  { name: "Coordinate Geometry -3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/38119925274719570.pdf" },
  { name: "Coordinate geometry-4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/100683109742101940.pdf" },
  { name: "Coordinate geometry-5", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/717126006237391600.pdf" },
  { name: "Revision Triangles 1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/649343919790321500.pdf" },
  { name: "Revision Triangles 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/236240495358860830.pdf" },
  { name: "Revision Triangles 3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540/course_pdf/7539682845200152696543700.pdf" },
  { name: "Revision Pair of Lin EQ in 2 Variable -1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/717483559620722600.pdf" },
  { name: "Revision Pair of Lin EQ in 2 Variable -2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/247209010049102370.pdf" },
  { name: "Revision Pair of Lin EQ in 2 Variable -3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/803490408055500700.pdf" },
  { name: "Half yearly Rev Quad Eq-1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/261604684923940960.pdf" },
  { name: "Half yearly Rev Quad Eq-2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/184830469946913820.pdf" },
  { name: "Half Yearly Revision Polynomials", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/9450476571404098.pdf" },
  { name: "Half Yearly Revision Real Numbers", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/192240876121614880.pdf" },
  { name: "Circles lecture 1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/11369366272154546.pdf" },
  { name: "Circles Lecture 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/377403691742728900.pdf" },
  { name: "Circles Lecture 3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/436095432456412900.pdf" },
  { name: "Circles|Lecture 4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/751449086239369200.pdf" },
  { name: "Area Related to circle 1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/547119871881596100.pdf" },
  { name: "Area related to circles 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/148027105869355200.pdf" },
  { name: "Area Related to Circles 3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/168687237586328800.pdf" },
  { name: "Area Related to Circle 4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/161890699284516130.pdf" },
  { name: "Surface are and Volume 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/401146922456167740.pdf" },
  { name: "Surface Area and Volume 3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/325266053793366700.pdf" },
  { name: "Surface area and volume 4", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/300110822767090500.pdf" },
  { name: "Statistics - 1", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/183254743766069220.pdf" },
  { name: "Statistics - 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/577608819872976500.pdf" },
  { name: "Statistics - 3", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/100042547533631360.pdf" },
  { name: "Probability - 2", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/701525411240676600.pdf" }
],
    },
    SST: {
      0:[
  {
    "name": "AARAMBH BATCH Social Science - 1st Class FREE | Power Sharing- Lecture 1 | Class 10th",
    "youtubeUrl": "https://www.youtube.com/watch?v=YyLWS_yIoms"
  },
  {
    "name": "Power Sharing - Lecture 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17129837278112649384/17129837278112649384_649384.m3u8"
  },
  {
    "name": "Power Sharing Lecture - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17130287982364649384/17130287982364649384_649384.m3u8"
  },
  {
    "name": "Power Sharing Lecture - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17131111451407649384/17131111451407649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Session",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17131869363705649384/17131869363705649384_649384.m3u8"
  },
  {
    "name": "Resources and Development - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17135881738965649384/17135881738965649384_649384.m3u8"
  },
  {
    "name": "Resources and Development - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17136288349335649384/17136288349335649384_649384.m3u8"
  },
  {
    "name": "Resources and Development - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17137141925506649384/17137141925506649384_649384.m3u8"
  },
  {
    "name": "Resources and Development - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17137919172655649384/17137919172655649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Session",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17141369546279649384/17141369546279649384_649384.m3u8"
  },
  {
    "name": "Resources and Development - 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17142336228201649384/17142336228201649384_649384.m3u8"
  },
  {
    "name": "Resources and Development - 6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17143186281180649384/17143186281180649384_649384.m3u8"
  },
  {
    "name": "The Rise Of Nationalism In Europe - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17144056412321649384/17144056412321649384_649384.m3u8"
  },
  {
    "name": "The Rise Of Nationalism In Europe - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17147425907230649384/17147425907230649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17148369667130649384/17148369667130649384_649384.m3u8"
  },
  {
    "name": "The Rise Of Nationalism In Europe - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17150011565016649384/17150011565016649384_649384.m3u8"
  },
  {
    "name": "The Rise of Nationalism in Europe - 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17153595915108649384/17153595915108649384_649384.m3u8"
  },
  {
    "name": "The Rise of Nationalism in Europe - 6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17154424674251649384/17154424674251649384_649384.m3u8"
  },
  {
    "name": "The Rise of Nationalism in Europe - 7",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17155275125960649384/17155275125960649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17156056224746649384/17156056224746649384_649384.m3u8"
  },
  {
    "name": "The Nationalism in Europe - 8",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17160380281113649384/17160380281113649384_649384.m3u8"
  },
  {
    "name": "The Rise of Nationalism In Europe - 9",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17161334644454649384/17161334644454649384_649384.m3u8"
  },
  {
    "name": "The Rise of Nationalism In Europe - 10",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17162108314730649384/17162108314730649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17165565215854649384/17165565215854649384_649384.m3u8"
  },
  {
    "name": "Development - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17166516995920649384/17166516995920649384_649384.m3u8"
  },
  {
    "name": "Development - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17167382266300649384/17167382266300649384_649384.m3u8"
  },
  {
    "name": "Development - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17168153633966649384/17168153633966649384_649384.m3u8"
  },
  {
    "name": "Development - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17180340074292649384/17180340074292649384_649384.m3u8"
  },
  {
    "name": "Federalism - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17180340074292649384/17180340074292649384_649384.m3u8"
  },
  {
    "name": "Federalism - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17181211522469649384/17181211522469649384_649384.m3u8"
  },
  {
    "name": "Federalism - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17182064999480649384/17182064999480649384_649384.m3u8"
  },
  {
    "name": "Federalism - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17182936795463649384/17182936795463649384_649384.m3u8"
  },
  {
    "name": "SST doubt solving class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17186293167106649384/17186293167106649384_649384.m3u8"
  },
  {
    "name": "Federalism - 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17189759349261649384/17189759349261649384_649384.m3u8"
  },
  {
    "name": "Forest and Wildlife Resources - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17191570875588649384/17191570875588649384_649384.m3u8"
  },
  {
    "name": "Forest and Wildlife Resources - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17192342518384649384/17192342518384649384_649384.m3u8"
  },
  {
    "name": "Forest and Wildlife Resources - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17192436195662649384/17192436195662649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17195890452952649384/17195890452952649384_649384.m3u8"
  },
  {
    "name": "Nationalism in India - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17196665905631649384/17196665905631649384_649384.m3u8"
  },
  {
    "name": "Nationalism in India - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17199257035351649384/17199257035351649384_649384.m3u8"
  },
  {
    "name": "Nationalism in India - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17200219498358649384/17200219498358649384_649384.m3u8"
  },
  {
    "name": "Nationalism in India - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17203670994343649384/17203670994343649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17204439365397649384/17204439365397649384_649384.m3u8"
  },
  {
    "name": "Nationalism in India - 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17207896504953649384/17207896504953649384_649384.m3u8"
  },
  {
    "name": "Nationalism in India - 6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17208759348052649384/17208759348052649384_649384.m3u8"
  },
  {
    "name": "Nationalism in India - 7",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17209632394366649384/17209632394366649384_649384.m3u8"
  },
  {
    "name": "Nationalism in India - 8",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17210578113221649384/17210578113221649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17213945669794649384/17213945669794649384_649384.m3u8"
  },
  {
    "name": "Nationalism in India - 9",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17214899422201649384/17214899422201649384_649384.m3u8"
  },
  {
    "name": "Nationalism in India -10",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17215762347214649384/17215762347214649384_649384.m3u8"
  },
  {
    "name": "Nationalism in India -11",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17216543628282649384/17216543628282649384_649384.m3u8"
  },
  {
    "name": "Sectors of Indian Economy -1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17219994483478649384/17219994483478649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17220857602615649384/17220857602615649384_649384.m3u8"
  },
  {
    "name": "Sectors of Indian Economy - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17221721799585649384/17221721799585649384_649384.m3u8"
  },
  {
    "name": "Sectors of Indian Economy - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17222586425782649384/17222586425782649384_649384.m3u8"
  },
  {
    "name": "Sectors of Indian Economy - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17223553931198649384/17223553931198649384_649384.m3u8"
  },
  {
    "name": "Sectors of Indian Economy - 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17225270037284649384/17225270037284649384_649384.m3u8"
  },
  {
    "name": "Sectors of Indian Economy - 6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17226126118710649384/17226126118710649384_649384.m3u8"
  },
  {
    "name": "Sectors of Indian Economy - 7",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17226911011907649384/17226911011907649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17227849033391649384/17227849033391649384_649384.m3u8"
  },
  {
    "name": "Gender Religion and Caste - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17232087402271649384/17232087402271649384_649384.m3u8"
  },
  {
    "name": "Gender Religion and Caste - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17232957999372649384/17232957999372649384_649384.m3u8"
  },
  {
    "name": "Gender Religion and Caste - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17233823175257649384/17233823175257649384_649384.m3u8"
  },
  {
    "name": "Gender Religion and Caste - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17234683236558649384/17234683236558649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17238139292270649384/17238139292270649384_649384.m3u8"
  },
  {
    "name": "Gender Religion and Caste - 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17239107041300649384/17239107041300649384_649384.m3u8"
  },
  {
    "name": "Gender Religion and Caste - 6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17239971515225649384/17239971515225649384_649384.m3u8"
  },
  {
    "name": "Water Resources - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17244183951783649384/17244183951783649384_649384.m3u8"
  },
  {
    "name": "Water Resources - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17245140267892649384/17245140267892649384_649384.m3u8"
  },
  {
    "name": "Water Resources - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17246012877694649384/17246012877694649384_649384.m3u8"
  },
  {
    "name": "Water Resources - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17246770419493649384/17246770419493649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17250230287618649384/17250230287618649384_649384.m3u8"
  },
  {
    "name": "The Making of Global World - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17251204702229649384/17251204702229649384_649384.m3u8"
  },
  {
    "name": "Money and Credit - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17252065848999649384/17252065848999649384_649384.m3u8"
  },
  {
    "name": "Money and Credit - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17252822286960649384/17252822286960649384_649384.m3u8"
  },
  {
    "name": "Money and Credit - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17256277955602649384/17256277955602649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17257250229492649384/17257250229492649384_649384.m3u8"
  },
  {
    "name": "Money and Credit - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17258111905537649384/17258111905537649384_649384.m3u8"
  },
  {
    "name": "Money and Credit L - 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17258871495429649384/17258871495429649384_649384.m3u8"
  },
  {
    "name": "Agriculture - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17262317223529649384/17262317223529649384_649384.m3u8"
  },
  {
    "name": "Agriculture - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17263190565284649384/17263190565284649384_649384.m3u8"
  },
  {
    "name": "Agriculture - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17264049976491649384/17264049976491649384_649384.m3u8"
  },
  {
    "name": "Agriculture - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17264905481856649384/17264905481856649384_649384.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17268391297807649384/17268391297807649384_649384.m3u8"
  },
  {
    "name": "Political Parties - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17269348145919649384/17269348145919649384_649384.m3u8"
  },
  {
    "name": "Political Parties - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17270199593509649384/17270199593509649384_649384.m3u8"
  },
  {
    "name": "Political Parties - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17270965213441649384/17270965213441649384_649384.m3u8"
  },
  {
    "name": "Political Parties - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/17271929548836649384/17271929548836649384_649384.m3u8"
  },
  {
    "name": "Political Parties - 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172727990433611815381/172727990433611815381_1815381.m3u8"
  },
  {
    "name": "Political Parties - 6 & Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172788457975011815381/172788457975011815381_1815381.m3u8"
  },
  {
    "name": "Globalization And The Indian Economy -1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172796094871731815381/172796094871731815381_1815381.m3u8"
  },
  {
    "name": "Minerals and Energy Resources - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172804666393971815381/172804666393971815381_1815381.m3u8"
  },
  {
    "name": "Minerals and Energy Resources - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172805664351241815381/172805664351241815381_1815381.m3u8"
  },
  {
    "name": "Minerals and Energy Resources - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172832094678541815381/172832094678541815381_1815381.m3u8"
  },
  {
    "name": "Minerals and Energy Resources - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172821876985661815381/172821876985661815381_1815381.m3u8"
  },
  {
    "name": "Minerals and Energy Resources - 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172832045681981815381/172832045681981815381_1815381.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172865200380601815381/172865200380601815381_1815381.m3u8"
  },
  {
    "name": "Outcomes of Democracy 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172873373174521815381/172873373174521815381_1815381.m3u8"
  },
  {
    "name": "Outcomes of Democracy 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172891054119991815381/172891054119991815381_1815381.m3u8"
  },
  {
    "name": "Outcomes of Democracy 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172909383696221815381/172909383696221815381_1815381.m3u8"
  },
  {
    "name": "Outcomes of Democracy 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172925641547591815381/172925641547591815381_1815381.m3u8"
  },
  {
    "name": "Manufacturing Industries - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172934281316761815381/172934281316761815381_1815381.m3u8"
  },
  {
    "name": "Manufacturing Industries - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172935274991431815381/172935274991431815381_1815381.m3u8"
  },
  {
    "name": "Manufacturing Industries - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172951462132511815381/172951462132511815381_1815381.m3u8"
  },
  {
    "name": "Manufacturing Industries - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172952541058421815381/172952541058421815381_1815381.m3u8"
  },
  {
    "name": "Manufacturing Industries - 5 & Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172960263482521815381/172960263482521815381_1815381.m3u8"
  },
  {
    "name": "Print Culture and The Modern World - 1",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172968874616261815381/172968874616261815381_1815381.m3u8"
  },
  {
    "name": "Print Culture and The Modern World - 2",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172977455641771815381/172977455641771815381_1815381.m3u8"
  },
  {
    "name": "Print Culture and The Modern World - 3",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172986146924881815381/172986146924881815381_1815381.m3u8"
  },
  {
    "name": "Print Culture and The Modern World - 4",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/172994254576221815381/172994254576221815381_1815381.m3u8"
  },
  {
    "name": "Print Culture and The Modern World - 5",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/173012053720581815381/173012053720581815381_1815381.m3u8"
  },
  {
    "name": "Print Culture and The Modern World - 6",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/173020705778561815381/173020705778561815381_1815381.m3u8"
  },
  {
    "name": "Print Culture and The Modern World - 7",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/173030322681651815381/173030322681651815381_1815381.m3u8"
  },
  {
    "name": "Print Culture and The Modern World - 8",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/173072459434381815381/173072459434381815381_1815381.m3u8"
  },
  {
    "name": "Print Culture and The Modern World - 9 & Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/173082175059551815381/173082175059551815381_1815381.m3u8"
  },
  {
    "name": "Map Work",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/173089759353101815381/173089759353101815381_1815381.m3u8"
  },
  {
    "name": "Doubt Solving Class",
    "m3u8Url": "https://d1qcficr3lu37x.cloudfront.net/file_library/videos/channel_vod_non_drm_hls/173107155697101815381/173107155697101815381_1815381.m3u8"
  }
],
      1:
[
  { name: "Outcomes of Democrecy", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/263005453973522140.pdf" },
  { name: "Minerals and Energy Resources complete", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236293110_234591415083258430_video_VOD.pdf" },
  { name: "Globalisation and the Indian Economy pdf", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236290886_608770599928500500_video_VOD.pdf" },
  { name: "agricultural full pdf", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236276737_894537862759308900_video_VOD.pdf" },
  { name: "Money and credit final full", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236295822_626480272909827500_video_VOD.pdf" },
  { name: "water resources full ..", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236274998_300092503938816400_video_VOD.pdf" },
  { name: "gender religion and caste Complete", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236288988_535325025628280300_video_VOD.pdf" },
  { name: "sectors of the indian economy", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236269522_67600983363173304_video_VOD.pdf" },
  { name: "complete nationlism in india", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236278775_506878198083990140_video_VOD.pdf" },
  { name: "Political Parties complete", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236262689_308191772013795140_video_VOD.pdf" },
  { name: "Forest and Wildlife Resourses complete chapter_240624_221938", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236286344_37021298500602760_video_VOD.pdf" },
  { name: "federalism Complete", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236283654_406721388155324900_video_VOD.pdf" },
  { name: "Development Complete", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236282053_879447474714416300_video_VOD.pdf" },
  { name: "The rise of Nationalism in Europe complete chapter_Complete", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236272364_547769653961661250_video_VOD.pdf" },
  { name: "resources and development full pdf", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236268359_624868501752807200_video_VOD.pdf" },
  { name: "Power Sharing Complete Chapter", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/sst/1729236266605_421176385108896000_video_VOD.pdf" },
  { name: "Manufacturing industries", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/804935435036992900.pdf" },
  { name: "Minerals and Energy Resources Complete lec Notes", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/362468167708476800.pdf" },
  { name: "Globalisation and The Indian Economy Complete Notes", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/208002563730127330.pdf" },
  { name: "Political parties Complete Lecture Notes", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/757884827950364300.pdf" },
  { name: "Agriculture Complete Lec Notes", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/129790009822767360.pdf" },
  { name: "Money and Credit Complete chap Notes", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/860044379672611300.pdf" },
  { name: "Gender Religion and Caste Complete Chap. Notes", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/844638613338737800.pdf" },
  { name: "Water Resources Complete chap. Notes", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/136319227919049400.pdf" },
  { name: "Sectors of the Indian Economy Complete Lecture", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/791854785914284800.pdf" },
  { name: "Nationalism in India Complete chap Notes", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/893895041721439100.pdf" },
  { name: "Forest and Wildlife Resources complete chapter Notes", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/784519704962118400.pdf" },
  { name: "The making of Global World", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/849862060737540400.pdf" },
  { name: "Print culture and the modern world", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/514242913255031100.pdf" },
  { name: "Complete Map Work", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/671453502028092700.pdf" },
  { name: "WPP #5 Solutions - Federalism", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/506181599809094500.pdf" },
  { name: "WPP 12 Money and Credit", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/676408219454127400.pdf" },
  { name: "WPP #1 Power Sharing", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540/course_pdf/1275388486361407317683600.pdf" },
  { name: "WPP#1 Solution POWER SHARING", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/111875554942164720.pdf" },
  { name: "WPP-2 Resourced and Development", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/334495043781039100.pdf" },
  { name: "WPP#2 solution RESOURCES AND DEVELOPMENT", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/6724721976512860.pdf" },
  { name: "WPP #3 The rise of nationalism in EUROPE", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/714407061714614100.pdf" },
  { name: "WPP#4 -Development", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/340276762962641500.pdf" },
  { name: "WPP #5 -Federalism", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/620307215722181400.pdf" },
  { name: "WPP #6 Forests and Wildlife Resources", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/303527630171519800.pdf" },
  { name: "WPP #7 Nationalism In INDIA", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/711295093769772200.pdf" },
  { name: "DPP #7 Nationalism in India (solution)", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/74823435060066350.pdf" },
  { name: "WPP #8 SECTORS OF THE INDIAN ECONOMY", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/74274241211600060.pdf" },
  { name: "WPP#8 Sectors of the Indian Economy Solution", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/333006706771373060.pdf" },
  { name: "WPP #9-GENDER, RELIGION AND CASTE", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/143621442517084420.pdf" },
  { name: "WPP#9 SolutionGender Religion and Caste", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/461616753524205600.pdf" },
  { name: "WPP #10 water Resources", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/446712432945049000.pdf" },
  { name: "WPP#11 THE MAKING OF A GLOBAL WORLD", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/445473690172676160.pdf" },
  { name: "WPP#11 Solution The making of Global world", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540/course_pdf/508996557893205309152000.pdf" },
  { name: "WPP #12 money and credit Solutions", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/237764439568496200.pdf" },
  { name: "WPP #13 Agriculture", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/553907630957817000.pdf" },
  { name: "WPP #13 Agriculture Solution", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/408200696522379500.pdf" },
  { name: "WPP #10 Solution Water resources", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/618225981477737100.pdf" },
  { name: "WPP #14 Political Parties", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/660242550588226400.pdf" },
  { name: "WPP #15 Globalisation and the Indian economy", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/496668420422504960.pdf" },
  { name: "DPP #14 and #15 solutions", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/435750557293253500.pdf" },
  { name: "WPP #16 Minerals and Energy Resources", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/629824690322467000.pdf" },
  { name: "WPP#17 OUTCOMES OF DEMOCRACY", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/150057012920370400.pdf" },
  { name: "WPP #13 Agriculture solution", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/408521284002592060.pdf" },
  { name: "WPP #12 Money and Credit solution", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/507648044974798660.pdf" },
  { name: "WPP #9 Gender Religion and Caste solution", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/463415411270505600.pdf" },
  { name: "WPP # 8 Solution Sectors of Indian Economy", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/72717821958959060.pdf" },
  { name: "WPP #6 Solution Forest and Wildlife resources", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/725611169277749900.pdf" },
  { name: "WPP #18 Manufacturing Industries", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/143246868850108940.pdf" },
  { name: "WPP 19 Print culture and the Modern world", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/449178832100469100.pdf" },
  { name: "Doubt Solving And Pending Topics", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/282316640621975870.pdf" },
  { name: "WPP#16 Solution Minrals and energy Resources", redirect: "https://d3cx6qbbd4cbso.cloudfront.net/540admin_v1/file_manager/pdf/389427820922525200.pdf" }
],
    },
  };

  const handleLectureClick = (lecture) => {
    if (lecture.youtubeUrl) {
      window.location.href = lecture.youtubeUrl;
    }
  };

  return (
    <div className="chapter-lectures-container">
      <img src={mlogo} alt="Logo" className="big-logo" />
      <h2>{subject} - Chapter {parseInt(chapterIndex) + 1}</h2>
      <div className="lecture-boxes">
        {chapterLectures[subject]?.[chapterIndex]?.map((lecture, index) => {
          if (lecture.redirect) {
            return (
              <div
                key={index}
                onClick={() => window.location.href = lecture.redirect}
                className="lecture-box"
                style={{ cursor: "pointer" }}
              >
                {lecture.name} (PDF)
              </div>
            );
          } else if (lecture.youtubeUrl) {
            return (
              <div
                key={index}
                onClick={() => handleLectureClick(lecture)}
                className="lecture-box"
                style={{ cursor: "pointer" }}
              >
                {lecture.name} (YouTube)
              </div>
            );
          } else if (lecture.m3u8Url) {
            return (
              <Link
                key={index}
                to={`/video/${subject}/${chapterIndex}`}
                state={{
                  chapterName: lecture.name,
                  m3u8Url: lecture.m3u8Url,
                  notesUrl: lecture.notesUrl,
                }}
                className="lecture-box"
                onClick={() => {
              // Store chapter name and index in localStorage for later use
              localStorage.setItem("lectureName", lecture.name);  // Store chapter name
            }}
              >
                {lecture.name}
              </Link>
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};

export default ChapterLectures;
